import { Leaf, TelegramLogo, Star, Crown, HandHeart, ShieldStar } from '@phosphor-icons/react';
import type { Tier } from '@/lib/tiers';
import { cn } from '@/lib/utils';

/****************
 * ONE ICON PER TIER. Guillaume, 2026-09-26: the tier names in the locks did
 * not fit ("Standar" cut in French), "instead of calling it Regular, Telegram
 * and Premium, we should just have Icon for each." The name stays in the
 * tooltip and for screen readers; the icon and its colour carry it on screen.
 ****************/
const ICON = { free: Leaf, telegram: TelegramLogo, regular: Star, premium: Crown, privileged: HandHeart, admin: ShieldStar } as const;

/** Text colour per tier; the lock pills and the plans pop-up use the same. */
export const TIER_TONE: Record<Tier, string> = {
  free: 'text-muted-foreground',
  telegram: 'text-sky-400',
  regular: 'text-primary',
  premium: 'text-amber-400',
  privileged: 'text-violet-400',
  admin: 'text-destructive',
};

export function TierIcon({ tier, size = 12, className }: { tier: Tier; size?: number; className?: string }) {
  const Icon = ICON[tier];
  return <Icon size={size} weight="fill" className={cn(TIER_TONE[tier], className)} aria-hidden />;
}
